module.exports = __webpack_public_path__ + "assets/img/f48d12445de33b2b9b8902a763974c5d.png";